import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {SL4AnagrafService} from '../../../general-services/service-sl4-anagraf/sl4-anagraf.service';
import {L2Model} from '../../../../models/L2Model';
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-l2-anagraf',
  templateUrl: './new-sl4-anagraf.component.html',
  styleUrls: ['./new-sl4-anagraf.component.scss']
})
export class NewSl4AnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  l2: L2Model;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private sl4AnagrafService: SL4AnagrafService) {
    super();

    this.l2 = new L2Model();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.l2.cod, [Validators.required]],
      description: [this.l2.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL4_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.l2.cod = this.formValidator.value.cod;
      this.l2.description = this.formValidator.value.description;
      this.saveSubscribe = this.sl4AnagrafService.save(this.sl4AnagrafService.baseUrl, this.l2).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, SL4 Cod already exists', 'Warning');
          } else {
            toastr.success('Element added with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SL4_ANAGRF]);
          }
        }, error => {
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

}
